import { render, staticRenderFns } from "./OrganizationListItem.vue?vue&type=template&id=1b85280a&scoped=true&functional=true&"
import script from "./OrganizationListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationListItem.vue?vue&type=style&index=0&id=1b85280a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1b85280a",
  null
  
)

export default component.exports